import { Box, Typography } from '@mui/material'
import Link from 'next/link'
import React from 'react'
import { Autoplay, EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/effect-fade'
const SLIDE_TEXTS = [
  'Mua cho đáng, xài cho lâu',
  'Miễn phí vận chuyển cho đơn hàng trên 400k',
  'Đơn giản mà dễ dùng là được',
]
export default function SlideText() {
  return (
    <Box>
      <Swiper
        modules={[EffectFade, Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        effect={'fade'}
        speed={1000}
        fadeEffect={{
          crossFade: true,
        }}
        slidesPerView={1}
        loop={true}
        allowTouchMove={false}
      >
        {SLIDE_TEXTS.map((text, index) => (
          <SwiperSlide key={index}>
            <Typography
              component={'p'}
              color="inherit"
              sx={{
                fontWeight: 500,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                flex: 1,
                textAlign: 'center',
                fontSize: { xs: '0.75rem', lg: '0.875rem' },
                textTransform: 'uppercase',
                '& a': {
                  color: 'inherit',
                  textDecoration: 'none',
                },
              }}
            >
              <Link href={'/danh-muc-san-pham/'}>{text}</Link>
            </Typography>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  )
}
